import dayjs from 'dayjs'

export default function dayDate(date) {
  return date ? dayjs(date).format('dddd, MMM D') : '–'
}
